export function TrailerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* trailer body */}
      <rect x="1" y="5" width="16" height="11" rx="1" />
      {/* hitch */}
      <path d="M17 14h3" />
      <circle cx="21.5" cy="14" r="1.5" />
      {/* wheels */}
      <circle cx="5" cy="18" r="2" />
      <circle cx="12" cy="18" r="2" />
      {/* axle line */}
      <path d="M7 18h3" />
    </svg>
  )
}
